import { render, staticRenderFns } from "./DrawerBottomPayment.partial.vue?vue&type=template&id=96627ba0&scoped=true"
import script from "./DrawerBottomPayment.partial.vue?vue&type=script&lang=js"
export * from "./DrawerBottomPayment.partial.vue?vue&type=script&lang=js"
import style0 from "./DrawerBottomPayment.partial.vue?vue&type=style&index=0&id=96627ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96627ba0",
  null
  
)

export default component.exports